export const generateSessionID = () => {
  const RADIX = 16; // Base 16 for hexadecimal
  const RANDOM_MASK = 0x3; // Mask for the first two bits
  const VARIANT_BITS = 0x8; // Variant specific bits (10xx) for UUID variant

  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback custom UUID generation
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const randomValue = Math.random() * RADIX | 0;
    // eslint-disable-next-line no-bitwise,no-mixed-operators
    const value = c === 'x' ? randomValue : (randomValue & RANDOM_MASK | VARIANT_BITS);

    return value.toString(RADIX);
  });
};
